<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">

    <!-- 项目概况 -->
    <div class="white-box">
      <div class="label">项目概况</div>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="dataInfo.projectName" placeholder="请输入" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目所属产业类别" prop="cylb">
            <el-radio-group v-model="dataInfo.cylb" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in cylbOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
            <el-input v-if="dataInfo.cylb == CYLB_TYPE.OTHER.value" v-model="dataInfo.otherlb" placeholder="请输入" :disabled="disabled" style="width: 250px;margin-left: 15px"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="margin-top: 10px">
          <el-form-item label="" prop="gjzdzc">
            <div style="color:#606266">所属国家重点支持的高新技术领域<span style="color:#F25555">（注:国家科技部、财政部、税务总局《高新技术企业认定管理办法》及其附件《国家重点支持的高新技术领域》确定的高新技术领域）</span></div>
            <el-table :data="[dataInfo]" border >
              <el-table-column label="产业类别" min-width="180" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.gjzdzcCylb" placeholder="请选择" @change="gxjsCylbChange" :disabled="disabled">
                    <el-option v-for="item in gxjsCylbOptions" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="子项类别" min-width="180" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.gjzdzcZlb" placeholder="请选择" :disabled="disabled">
                    <el-option v-for="item in gxjsZlbOptions" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="具体领域"  align="center" min-width="360">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.gjzdzcRealm" placeholder="请输入" :disabled="disabled"/>
                </template>
              </el-table-column>

            </el-table>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="项目实施方式" prop="ssfs">
            <el-radio-group v-model="dataInfo.ssfs" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in ssfsOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
            <el-input v-if="dataInfo.ssfs == SSFS_TYPE.OTHER.value" v-model="dataInfo.otherSsfs" placeholder="请输入" :disabled="disabled" style="width: 250px;margin-left: 15px"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目技术水平" prop="jssp">
            <el-radio-group v-model="dataInfo.jssp" :disabled="disabled">
              <el-radio :label="item.value" v-for="(item) in jsspOptions" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主要竞争对手" prop="jzds">
            <el-input v-model="dataInfo.jzds" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目知识产权情况（附：项目有关知识产权证明复印件），【附件材料】处上传" prop="zscq">
            <el-input v-model="dataInfo.zscq" placeholder="请输入" type="textarea" :rows="4" :disabled="disabled"/>
          </el-form-item>
        </el-col>

      </el-row>
    </div>


  </el-form>
</template>

<script>

import {toast} from '@/utils'
import {findByKey, toList, JSSP_TYPE, SSFS_TYPE, CYLB_TYPE} from '@/constant/Enums'
import { getDictByKey, DICT_TYPES } from '@/constant/Dict';

export default {
  components: {
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {
          studyExpList: [{}],//学习经历
          workExpList: [{}],//工作经历
          sbrZzqkList: [],//主持国家和地方科技业项目及资助情况
        }
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkGjzdzc = (rule, value, callback) => {
      if (!this.dataInfo.gjzdzcCylb || !this.dataInfo.gjzdzcZlb || !this.dataInfo.gjzdzcRealm) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    var checkCylb = (rule, value, callback) => {
      if (!this.dataInfo.cylb) {
        return callback(new Error('请选择项目所属产业类别'));
      } else if (this.dataInfo.cylb == CYLB_TYPE.OTHER.value && !this.dataInfo.otherlb) {
        return callback(new Error('请填写项目所属产业类别'));
      } else {
        return callback();
      }
    };
    var checkSsfs = (rule, value, callback) => {
      if (!this.dataInfo.ssfs) {
        return callback(new Error('请选择项目实施方式'));
      } else if (this.dataInfo.ssfs == SSFS_TYPE.OTHER.value && !this.dataInfo.otherSsfs) {
        return callback(new Error('请填写项目实施方式'));
      } else {
        return callback();
      }
    };
    return {
      CYLB_TYPE,
      SSFS_TYPE,
      rules: {
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        cylb: [{ required: true, validator: checkCylb, trigger: 'change' }],
        gjzdzc: [{ required: true, validator: checkGjzdzc, message: '请填写所属国家重点支持的高新技术领域信息', trigger: 'change' }],
        ssfs: [{ required: true, validator: checkSsfs, trigger: 'change' }],
        jssp: [{ required: true, message: '请选择项目技术水平', trigger: 'change' }],
        jzds: [{ required: true, message: '请输入主要竞争对手', trigger: 'blur' }],
        zscq: [{ required: true, message: '请输入项目知识产权情况', trigger: 'blur' }],
      },
      cylbOptions:toList(CYLB_TYPE),//项目所属产业类别
      ssfsOptions:toList(SSFS_TYPE),//项目实施方式
      jsspOptions:toList(JSSP_TYPE),//项目技术水平
      gxjsCylbOptions:[],//高新技术领域-产业类别
      gxjsZlbOptions:[],//高新技术领域-子类别


    }
  },
  mounted() {
  },
  methods: {
    async init() {
      this.gxjsCylbOptions = await getDictByKey(DICT_TYPES.CYLB)
      setTimeout(async () => {
        if (this.dataInfo.gjzdzcCylb) {
          this.gxjsZlbOptions = await getDictByKey(this.dataInfo.gjzdzcCylb)
        }
      }, 0)
    },
    async gxjsCylbChange(val) {
      if (val) {
        this.dataInfo.gjzdzcZlb = ''
        this.gxjsZlbOptions = await getDictByKey(val)
      }

    },
    addStudyExp(){
      this.dataInfo.studyExpList.push({})
    },
    deleteStudyExp(index){
      this.dataInfo.studyExpList.splice(index, 1)
    },
    timeChange(times, data){
      if(times && times.length > 1) {
        data.startDate = times[0]
        data.endDate = times[1]
      } else {
        data.startDate = ''
        data.endDate = ''
      }
    },
    addWorkExp(){
      this.dataInfo.workExpList.push({})
    },
    deleteWorkExp(index){
      this.dataInfo.workExpList.splice(index, 1)
    },
    addZzqk(){
      this.dataInfo.sbrZzqkList.push({})
    },
    deleteZzqk(index){
      this.dataInfo.sbrZzqkList.splice(index, 1)
    },
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
